import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCancel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 11,
	viewBox: "0 0 16 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6 2.93333C14.0301 2.93333 16 4.73912 16 6.96667C16 9.19422 14.0301 11 11.6 11H8C7.55817 11 7.2 10.6717 7.2 10.2667C7.2 9.86166 7.55817 9.53333 8 9.53333H11.6C13.1464 9.53333 14.4 8.3842 14.4 6.96667C14.4 5.54914 13.1464 4.4 11.6 4.4H2.73137L4.56569 6.08146C4.8781 6.36784 4.8781 6.83216 4.56569 7.11854C4.25327 7.40493 3.74673 7.40493 3.43431 7.11854L0.234314 4.18521C-0.0781059 3.89883 -0.0781059 3.43451 0.234314 3.14812L3.43431 0.214788C3.74673 -0.0715961 4.25327 -0.0715961 4.56569 0.214788C4.8781 0.501173 4.8781 0.965493 4.56569 1.25188L2.73137 2.93333H11.6Z",
		fill: "white"
	})
});
export default SvgArrowCancel;
